import { useState } from "react";
import { Sun, Moon } from "@phosphor-icons/react";
import { getTheme, toggleTheme } from "@/lib/theme";

export default function ThemeToggle() {
  const [theme, setTheme] = useState(getTheme());
  return (
    <button
      onClick={() => setTheme(toggleTheme())}
      data-testid="theme-toggle"
      aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      title={theme === "dark" ? "Light mode" : "Dark mode"}
      className="inline-flex items-center justify-center w-9 h-9 border border-gray-300 text-gray-600 hover:border-gray-900 hover:text-gray-900 transition-colors"
    >
      {theme === "dark" ? <Sun size={18} weight="duotone" /> : <Moon size={18} weight="duotone" />}
    </button>
  );
}
